import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <section className="section">
      <div className="container">
        <div className="news-empty state-panel section-head section-head-notfound reveal">
          <p className="eyebrow">404</p>
          <h2>Page not found</h2>
          <p>The page you are looking for does not exist.</p>
          <p>
            <Link to="/">Go home</Link>
          </p>
        </div>
      </div>
    </section>
  );
}


